import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HookSection } from '../components/HookSection';
import { ProblemSection } from '../components/ProblemSection';
import { MethodSection } from '../components/MethodSection';
import { DeliverablesSection } from '../components/DeliverablesSection';
import { AudienceSection } from '../components/AudienceSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { ProofSection } from '../components/ProofSection';
import { FAQSection } from '../components/FAQSection';
import { OfferBlock } from '../components/OfferBlock';
export function LandingPage() {
  return <main className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#F5A623]/30 selection:text-[#2D2A26] overflow-x-hidden" data-id="element-135">
      <HeroSection data-id="element-136" />
      <HookSection data-id="element-137" />
      <ProblemSection data-id="element-138" />
      <MethodSection data-id="element-139" />
      <DeliverablesSection data-id="element-140" />
      <AudienceSection data-id="element-141" />
      <HowItWorksSection data-id="element-142" />
      <ProofSection data-id="element-143" />
      <FAQSection data-id="element-144" />
      <OfferBlock data-id="element-145" />

      <footer className="py-8 text-center text-[#2D2A26]/50 text-sm" data-id="element-146">
        <p data-id="element-147">
          © {new Date().getFullYear()} Hijos que Escuchan. Todos los derechos
          reservados.
        </p>
      </footer>
    </main>;
}